import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA3B60nDO85MxU1wLMmjeTzvGPqe3x1Pqw",
  authDomain: "pacoca-493322.firebaseapp.com",
  projectId: "pacoca-493322",
  storageBucket: "pacoca-493322.firebasestorage.app",
  messagingSenderId: "326727218280",
  appId: "1:326727218280:web:6cf351b43893e6e41d37dd"
};

const app = initializeApp(firebaseConfig);

const getMessagingInstance = async () => {
  const supported = await isSupported();
  if (!supported) return null;

  return getMessaging(app);
};

export { getMessagingInstance };